import axios from '@/axios/axios2'

// 获取我的商户基础信息
export const fetchBusinessBaseInfo = params =>
  axios.post('/business/getBusinessBaseInfo', params)

// 获取我的商户详情信息
export const fetchBusinessDetails = params =>
  axios.post('/business/getBusinessDetails', params)

// 获取商户转移信息
export const fetchChangepartner = params =>
  axios.post('/business/init_changepartner', params)

// 获取商户手机号
export const fetchBusinessTel = params =>
  axios.post('/business/getBusinessTel', params)

// 可选机具列表
export const multiMachineList = params =>
  axios.post('/multi/machineList', params)
// 短信发送
export const multiSmsSend = params => axios.post('/multi/smsSend', params)
// 机具换绑
export const multiChangeBind = params => axios.post('/multi/changeBind', params)
// 机具换绑开关
export const multiShowBtn = params => axios.post('/multi/showBtn', params)
